


// import abi from './Socoin.json'
import abi from './NewSocoin.json'

export const contractABI=abi;
// export const contractAddress='0x2C514a85Fa08e0fcC230C4A2A426FA82d55ff6B4';
// export const contractAddress='0xe6b3E64632F04FfD6991c3f368462F452fD9376c';
// export const contractAddress='0xb36f183af72914B8caC5677A0cdE96956FdABF82';
export const contractAddress='0xac959c9c6FFC6b914566e2e3ff651C56eEAc1f4f';


